"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_2 = require("@remirror/react");
const Button_1 = __importDefault(require("../../../ui/Button/Button"));
const RedoRounded_1 = __importDefault(require("@mui/icons-material/RedoRounded"));
const getShortcutSymbol_1 = require("../../../utils/getShortcutSymbol");
const RedoButton = () => {
    const { redo } = (0, react_2.useCommands)();
    const { redoDepth } = (0, react_2.useHelpers)(true);
    const handleSelect = () => {
        if (redo.enabled()) {
            redo();
        }
    };
    const enabled = redoDepth() > 0;
    return (react_1.default.createElement(Button_1.default, { handleOnClick: handleSelect, isDisabled: !enabled, isActive: false, icon: react_1.default.createElement(RedoRounded_1.default, null), label: `Redo (Shift+${(0, getShortcutSymbol_1.getShortcutSymbol)()}+Z)` }));
};
exports.default = RedoButton;
